function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncidental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.456,
    height: 98.026,
    viewBox: "0 0 72.456 98.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1590"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1588"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1587",
    transform: "translate(-675.129 -1764.276)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1572"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1570"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17859",
    d: "M742.914 1895.463H679.8a4.677 4.677 0 0 1-4.672-4.672v-83.8a4.677 4.677 0 0 1 4.672-4.672h15.249v1.924H679.8a2.75 2.75 0 0 0-2.747 2.747v83.8a2.751 2.751 0 0 0 2.747 2.747h63.113a2.751 2.751 0 0 0 2.747-2.747v-83.8a2.75 2.75 0 0 0-2.747-2.747h-15.248v-1.924h15.249a4.677 4.677 0 0 1 4.672 4.672v83.8a4.677 4.677 0 0 1-4.672 4.672z",
    transform: "translate(0 -33.161)",
    style: {
      fill: "#7EEAFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1571",
    transform: "translate(694.088 1764.276)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 269",
    width: 32.614,
    height: 9.758,
    rx: 4.879,
    transform: "translate(.962 .962)",
    style: {
      fill: "#7EEAFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17860",
    d: "M852.793 1775.958H827.6a4.677 4.677 0 0 1-4.672-4.672v-2.339a4.677 4.677 0 0 1 4.672-4.672h25.2a4.677 4.677 0 0 1 4.672 4.672v2.339a4.677 4.677 0 0 1-4.679 4.672zm-25.2-9.758a2.751 2.751 0 0 0-2.747 2.747v2.339a2.751 2.751 0 0 0 2.747 2.747h25.2a2.751 2.751 0 0 0 2.747-2.747v-2.339a2.751 2.751 0 0 0-2.747-2.747z",
    transform: "translate(-822.926 -1764.276)",
    style: {
      fill: "#7EEAFF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1576"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1573"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 189",
    transform: "translate(714.529 1795.017)",
    style: {
      fill: "#7cccce"
    },
    d: "M0 0h23.197"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17861",
    d: "M998.933 1998.346h-23.2a.962.962 0 1 1 0-1.924h23.2a.962.962 0 1 1 0 1.924z",
    transform: "translate(-261.207 -202.367)",
    style: {
      fill: "#7EEAFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1574"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 190",
    transform: "translate(714.529 1799.909)",
    style: {
      fill: "#7cccce"
    },
    d: "M0 0h23.197"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17862",
    d: "M998.933 2036.479h-23.2a.962.962 0 1 1 0-1.924h23.2a.962.962 0 1 1 0 1.924z",
    transform: "translate(-261.207 -235.608)",
    style: {
      fill: "#7EEAFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1575"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 191",
    transform: "translate(714.529 1804.8)",
    style: {
      fill: "#7cccce"
    },
    d: "M0 0h23.197"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17863",
    d: "M998.933 2074.613h-23.2a.962.962 0 1 1 0-1.924h23.2a.962.962 0 1 1 0 1.924z",
    transform: "translate(-261.207 -268.851)",
    style: {
      fill: "#7EEAFF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1580"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1577"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 192",
    transform: "translate(714.529 1824.868)",
    style: {
      fill: "#7cccce"
    },
    d: "M0 0h23.197"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17864",
    d: "M998.933 2231.053h-23.2a.962.962 0 1 1 0-1.924h23.2a.962.962 0 1 1 0 1.924z",
    transform: "translate(-261.207 -405.223)",
    style: {
      fill: "#7EEAFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1578"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 193",
    transform: "translate(714.529 1829.76)",
    style: {
      fill: "#7cccce"
    },
    d: "M0 0h23.197"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17865",
    d: "M998.933 2269.186h-23.2a.962.962 0 1 1 0-1.924h23.2a.962.962 0 1 1 0 1.924z",
    transform: "translate(-261.207 -438.464)",
    style: {
      fill: "#7EEAFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1579"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 194",
    transform: "translate(714.529 1834.651)",
    style: {
      fill: "#7cccce"
    },
    d: "M0 0h23.197"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17866",
    d: "M998.933 2307.32h-23.2a.962.962 0 0 1 0-1.924h23.2a.962.962 0 0 1 0 1.924z",
    transform: "translate(-261.207 -471.707)",
    style: {
      fill: "#7EEAFF"
    }
  }))), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3631",
    cx: 10.936,
    cy: 10.936,
    r: 10.936,
    transform: "rotate(-45 2512.911 78.569)",
    style: {
      opacity: 0.35,
      fill: "#7EEAFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17867",
    d: "M756.385 1973.1a11.9 11.9 0 1 1 11.9-11.9 11.911 11.911 0 0 1-11.9 11.9zm0-21.871a9.974 9.974 0 1 0 9.974 9.974 9.985 9.985 0 0 0-9.974-9.974z",
    transform: "translate(-60.461 -161.294)",
    style: {
      fill: "#7EEAFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 3632",
    cx: 10.936,
    cy: 10.936,
    r: 10.936,
    transform: "translate(684.988 1818.824)",
    style: {
      opacity: 0.35,
      fill: "#7EEAFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17868",
    d: "M756.385 2205.807a11.9 11.9 0 1 1 11.9-11.9 11.911 11.911 0 0 1-11.9 11.9zm0-21.871a9.974 9.974 0 1 0 9.974 9.974 9.985 9.985 0 0 0-9.974-9.974z",
    transform: "translate(-60.461 -364.15)",
    style: {
      fill: "#7EEAFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1582"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1581"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17869",
    d: "m785.823 2012.84-3.487-5.21 1.6-1.07 2.247 3.358 8.637-7.821 1.292 1.427z",
    transform: "translate(-93.455 -207.315)",
    style: {
      fill: "#7EEAFF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1585"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1583"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 270",
    transform: "rotate(-50.736 2271.293 185.619)",
    style: {
      fill: "#7EEAFF"
    },
    d: "M0 0h1.924v13.795H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1584"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 271",
    transform: "rotate(-39.267 2915.39 -50.258)",
    style: {
      fill: "#7EEAFF"
    },
    d: "M0 0h13.795v1.924H0z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidental);
export default __webpack_public_path__ + "static/media/incidental.45381b3fcfa8c70f8dcbac250ae8e565.svg";
export { ForwardRef as ReactComponent };